module.exports = __webpack_public_path__ + "static/media/Donate_teal.fa4dbd1f.png";